var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.elementStyles, _vm.basicContentStyles])},[_c('div',{style:(_vm.iconStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }